import { Route, Routes } from 'react-router-dom'
import Andrea from './index'
import AndreaHome from './pages/AndreaHome'
import EnduringMaterials from './pages/EnduringMaterials'
import Congress from './pages/Congress'
import Concepts from './pages/Concepts'
import EmailSignIn from './pages/EmailSignIn'
import EmailVerification from './pages/EmailVerification'

export const andreaRoutes = {
  subdomain: 'andrea',
  routes: () => (
    <Routes>
      <Route path='/' element={<Andrea />}>
        <Route path='' element={<AndreaHome />} />
        <Route path='concepts' element={<Concepts />} />
        <Route path='congress' element={<Congress />} />
        <Route path='enduring-materials' element={<EnduringMaterials />} />
        {/* <Route path='email-sign-in' element={<EmailSignIn />} />
        <Route path='email-verification' element={<EmailVerification />} /> */}
      </Route>
    </Routes>
  ),
}
